<!--
 * @Date: 2022-09-26 10:50:19
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-13 11:21:35
 * @description: description
-->
<template>
  <div :class="$style.partner">
    <div :class="$style.title">
      {{ info.title }}
    </div>
    <div :class="$style.tabBar">
      <ul :class="$style.tabsBox">
        <li
          v-for="tab in info.tabs"
          :key="tab.alias"
          :class="{ [$style.on]: cur == tab.id }"
          @mouseenter="onMouseEnter(tab)"
          @mouseleave="onMouseLeave"
        >
          <div>{{ tab.name }}</div>
        </li>
      </ul>
    </div>
    <div :class="$style.contentBox">
      <div
        :class="$style.itemBox"
        v-for="item in curModule.content"
        :key="item.id"
      >
        <div :class="$style.cover" v-if="showCover"></div>
        <div :class="$style.itemContent">{{ item.info }}</div>
        <div :class="$style.inscribeBox">
          <div :class="$style.itemline"></div>
          <div :class="$style.itemInscribe">{{ item.inscribe }}</div>
        </div>
      </div>
    </div>

    <div :class="$style.btn" @click="jump()">查看更多伙伴</div>
  </div>
</template>
<script>

export default {
  name: 'aboutus-partner',
  props: {
    info: Object
  },
  data () {
    return {
      cur: 1,
      timer: null,
      showCover: false
    }
  },
  computed: {
    curModule () {
      const find = this.info.tabs.find(item => item.id === this.cur)
      return find || {}
    },
    currentContent () {
      return this.curModule.content || {}
      // const find = this.info.modules.find(item => item.alias === this.cur)
      // return (find && find.content) || {}
    }
  },
  created () {
  },
  methods: {
    onMouseEnter (tab) {
      this.timer = setTimeout(() => {
        this.cur = tab.id
        this.showCover = true
        setTimeout(() => {
          this.showCover = false
        }, 200)
      }, 100)
    },
    onMouseLeave () {
      clearTimeout(this.timer)
      this.timer = null
      this.showCover = false
    },
    jump () {
      window.open('https://www.geekbang.org/partner')
    }
  }

}
</script>

<style lang="scss" module>
.partner {
  width: 1200px;
  margin: 0 auto 60px;
  padding-top: 63px;

  .title {
    position: relative;
    height: 45px;
    margin-bottom: 43px;
    line-height: 45px;
    text-align: center;
    font-size: 32px;
    font-weight: 500;
    color: #404040;
  }

  .tabBar {
    position: relative;
    // padding: 22px 0;
    width: 960px;
    margin: 0 auto;
    padding-bottom: 18px;
    border-bottom: 1px solid #ededed;

    &:before {
      content: "";
      position: absolute;
      top: -90px;
      left: -63px;
      width: 215px;
      height: 160px;
      background-image: url("../../../assets/img/aboutus/pc/partner/partner-title-bg.png");
      background-size: 100% 100%;
    }

    & > ul {
      display: flex;
      justify-content: space-between;
      padding: 0;
      margin: 0;

      & li {
        position: relative;
        // @extend %center;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 320px;
        line-height: 26px;
        font-size: 24px;
        font-weight: 400;
        // letter-spacing: 1px;
        color: #888888;
        // background: #d8d8d8;
        cursor: pointer;

        // &:before {
        //   content: "";
        //   display: block;
        //   width: 24px;
        //   height: 24px;
        //   margin-right: 10px;
        //   background-repeat: no-repeat;
        //   background-size: 24px 24px;
        // }

        &.on {
          color: #fa6400;
          font-weight: 500;

          &:after {
            content: "";
            position: absolute;
            bottom: -19px;
            left: 0;
            right: 0;
            height: 2px;
            background: #fa6400;
            border-radius: 2px;
          }
        }

        &:first-child {
          & .icon {
            margin-right: 13px;
            font-size: 24px;
          }
        }
      }
    }
  }

  .contentBox {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 48px 20px 40px;

    &:before {
      content: "";
      position: absolute;
      right: -280px;
      bottom: -23px;
      width: 195px;
      height: 279px;
      //   background-image: url("../../../assets/img/aboutus/pc/partner/partner-right-bg.png");
      background: url("../../../assets/img/aboutus/pc/partner/partner-right-bg.png")
        no-repeat center;
      background-size: 100% 100%;
    }
  }

  .itemBox {
    position: relative;
    box-sizing: border-box;
    width: 560px;
    height: 312px;
    background: linear-gradient(163deg, #fff5e7 0%, #ffffff 100%);
    box-shadow: 0px 8px 32px 0px rgba(206, 211, 226, 0.24),
      inset 2px 2px 0px 0px #ffffff;
    border-radius: 6px;

    &:before {
      content: "";
      position: absolute;
      top: -7px;
      left: 25px;
      width: 30px;
      height: 25px;
      background: url("../../../assets/img/aboutus/pc/partner/partner-box-bg.png")
        no-repeat center;
      background-size: 100% 100%;
    }
  }

  .itemBox {
    padding: 40px 30px 0;
  }

  .itemContent {
    width: 500px;
    margin-bottom: 16px;
    line-height: 28px;
    font-size: 16px;
    font-weight: 400;
    color: #404040;
  }

  .inscribeBox {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .itemline {
    height: 1px;
    width: 80px;
    margin-right: 8px;
    background: #979797;
  }

  .itemInscribe {
    height: 20px;
    text-align: right;
    line-height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #7f848c;
  }

  .btn {
    width: 260px;
    height: 44px;
    margin: 0 auto;
    background: linear-gradient(315deg, #ffd492 0%, #fa8919 100%);
    border-radius: 25px;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    cursor: pointer;

    &:hover {
      width: 260px;
      height: 44px;
      background: linear-gradient(315deg, #ffba4e 0%, #ff7f00 100%);
      border-radius: 25px;
    }
  }

  .cover {
    position: absolute; top: 0; right: 0; bottom: 0; left: 0; z-index: 999;
    background: #fff;
    opacity: 0;
    animation: flash 0.2s ease-in;
  }
}

@keyframes flash {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
